import React from 'react';
import classnames from 'classnames';
import { Icon } from 'js/components';

function FavoriteStamp({
  favorited = false,
  payload = null,
  onClick = () => {},
  disabled = false,
  className = '',
  'data-testid': dataTestId,
}) {
  const handleClick = (e) => {
    if (disabled) return;
    e.preventDefault();
    onClick(payload);
  };
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(payload);
    }
  };

  return (
    <div
      className={classnames({ favorite: favorited }, className)}
      data-testid={dataTestId}
    >
      <div
        className="stamp"
        role="button"
        tabIndex={disabled ? -1 : 0}
        aria-pressed={favorited}
        aria-disabled={disabled}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
      >
        <span className="fa-layers fa-fw">
          <Icon icon="star" className="background-layer" />
          <Icon icon={['far', 'star']} />
        </span>
      </div>
    </div>
  );
}

export default FavoriteStamp;
